import { Button, Container, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';

import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getCityData, saveApiData, setCityData } from '../../store/Slice/Global/GlobalSlice';
import { UserApi } from '../../utils/Apis';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import {
  getReportingManagerList,
  getReportingManagerList2
} from '../../store/Slice/Onboarding/OnboardingSlice';
import useUserSelector from '../../store/Slice/User/UserSelector';

function AddEditUser() {
  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      gender: '',
      typeId: '',
      accessLevelId: '',
      // relationshipManagerId: '',
      reportingManagerId: '',
      departmentName: '',
      stateId: '',
      cityName: ''
    }
  });

  const { rowId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { AccessLevelList, stateDrop, CityDrop, DepartmentListDrop } = useGlobalSelector();
  console.log('stateDrop222', stateDrop);

  const { ReportingManagerListData2 } = useOnboardingSelector();
  const { UserViewListData } = useUserSelector();
  // console.log('UserViewListData222', UserViewListData);
  // console.log('ReportingManagerListData2 in addedit', ReportingManagerListData2);

  const selectedCity = watch('cityName');

  const userTypeMap = {
    'Employee User': 304,
    'Partner User': 302
  };

  //  city api
  const handleGetCity = useCallback(
    (stateValue) => {
      const stateId = stateValue?.value ?? stateValue;

      if (!stateId) {
        dispatch(setCityData([]));
        setValue('cityName', null);
        return;
      }

      setValue('stateId', stateId);

      dispatch(
        getCityData({
          stateId,
          searchLiteral: ''
        })
      );
    },
    [dispatch, setValue]
  );

  /* -------------------- PREFILL ON EDIT -------------------- */
  useEffect(() => {
    if (!rowId || !UserViewListData || !stateDrop?.length) return;

    const data = UserViewListData;

    const userStateId =
      UserViewListData?.stateName ??
      UserViewListData?.stateId ??
      UserViewListData?.province ??
      null;

    const selectedState =
      stateDrop.find((s) => String(s.label) === String(userStateId)) ||
      stateDrop.find(
        (s) =>
          String(s.label || '')
            .trim()
            .toLowerCase() ===
          String(UserViewListData?.stateName || '')
            .trim()
            .toLowerCase()
      );
    // console.log('selectedState222', selectedState);
    reset({
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      email: data.email || '',
      mobile: data.mobile || '',
      gender: data.gender || '',
      typeId: userTypeMap[data.userType] || '',
      accessLevelId: Number(data.accessLevelId) || '',
      userName: data.userName || '',
      stateId: selectedState?.label || '',
      cityName: '', // ⬅️ IMPORTANT: set empty initially
      departmentName: data.departmentId ?? data.departmentName ?? '',
      reportingManagerId: data?.reportingManagerId ?? data.reportingManagerId ?? ''
    });

    // Load city list AFTER reset
    if (selectedState?.value) {
      setValue('stateId', selectedState.value);
      dispatch(
        getCityData({
          stateId: selectedState.value,
          searchLiteral: ''
        })
      );
    }
  }, [rowId, UserViewListData, stateDrop, reset, dispatch]);

  /* -------------------- SUBMIT -------------------- */
  const onSubmit = useCallback(
    async (data) => {
      const payload = {
        userId: rowId ? Number(rowId) : null,
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        mobile: data?.mobile,
        gender: data?.gender,
        typeId: Number(data?.typeId),
        accessLevelId: Number(data?.accessLevelId),
        // relationshipManagerId: null,
        reportingManagerId: data?.reportingManagerId,
        stateId: Number(data?.stateId ?? data?.stateId ?? null),
        // if API expects a city id:
        cityId: Number(
          (data?.cityName && (data.cityName.value ?? data.cityName)) ?? data?.cityId ?? null
        ),
        // hidden / backend-required
        departmentId: Number(data.departmentName || data.departmentId || 41),
        loggedInUserId: LoginData?.userId || '',
        companyId: LoginData?.companyId,
        startDate: '2025-12-15'
      };

      const res = await dispatch(saveApiData(UserApi?.addUpdateUser, payload));

      // console.log('sss saveApiData res', res);
      if (res?.status === 'success') {
        navigate('/users/');
      }
    },
    [LoginData, rowId]
  );

  const reportingMangerTwoApi = useCallback(() => {
    const credential = {
      userId: LoginData?.userId
    };
    dispatch(getReportingManagerList2(credential));
  }, []);

  useEffect(() => {
    reportingMangerTwoApi();
  }, [reportingMangerTwoApi]);

  useEffect(() => {
    if (!rowId && !selectedCity) return;

    if (!ReportingManagerListData2?.length) return;

    if (rowId && UserViewListData?.relationshipManagerId) {
      const rmExists = ReportingManagerListData2.some(
        (rm) => rm.userId === UserViewListData.relationshipManagerId
      );

      if (rmExists) {
        setValue('relationshipManagerId', UserViewListData.relationshipManagerId);
      }
    }
  }, [rowId, selectedCity, ReportingManagerListData2, UserViewListData, setValue]);

  useEffect(() => {
    if (!rowId) return;
    if (!UserViewListData || !CityDrop?.length) return;

    const cityId = UserViewListData.cityId ?? UserViewListData.cityName;
    if (cityId === undefined || cityId === null) return;

    const match =
      CityDrop.find((c) => String(c.value) === String(cityId)) ||
      CityDrop.find(
        (c) =>
          String(c.label || '')
            .trim()
            .toLowerCase() ===
          String(UserViewListData.cityName || '')
            .trim()
            .toLowerCase()
      );

    if (match) {
      setValue('cityName', match.value ?? match);
    }
  }, [CityDrop, UserViewListData, setValue, rowId]);

  useEffect(() => {
    if (!rowId) return;
    if (!UserViewListData || !DepartmentListDrop?.length) return;

    const depId = UserViewListData.departmentId ?? UserViewListData.departmentName;
    if (depId === undefined || depId === null) return;

    const firstOpt = DepartmentListDrop[0];
    // If options are objects with { value, label }
    if (firstOpt && typeof firstOpt === 'object' && 'value' in firstOpt) {
      const match = DepartmentListDrop.find(
        (d) => String(d.value) === String(depId) || String(d.label) === String(depId)
      );
      if (match) setValue('departmentName', match.value);
    } else {
      // options are primitives
      const match = DepartmentListDrop.find((d) => String(d) === String(depId));
      if (match) setValue('departmentName', match);
    }
  }, [rowId, UserViewListData, DepartmentListDrop, setValue]);

  return (
    <Page title="Kpros || User">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info={rowId ? 'Edit User' : 'Add New User'} />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            User Details
          </Typography>

          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <form id="addEditUser" onSubmit={handleReduxSubmit(onSubmit)}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <CustomInput
                    name="firstName"
                    label="First Name"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="NAME"
                    fieldType="ALPHABET"
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomInput
                    name="lastName"
                    label="Last Name"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="NAME"
                    fieldType="ALPHABET"
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomInput
                    name="email"
                    label="Email"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="EMAIL"
                    fieldType="EMAIL"
                    disabled={rowId}
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomInput
                    name="mobile"
                    label="Mobile"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="MOBILE"
                    fieldType="NUMBER"
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomSelect
                    name="gender"
                    label="Gender"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { id: 'MALE', value: 'MALE', label: 'Male' },
                      { id: 'FEMALE', value: 'FEMALE', label: 'Female' }
                    ]}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="departmentName"
                    label="Department"
                    control={control}
                    errors={errors}
                    isRequired
                    options={DepartmentListDrop || []}
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomSelect
                    name="stateId"
                    label="State"
                    control={control}
                    errors={errors}
                    options={stateDrop || []}
                    onChange={(event, val, option, reason, details) => {
                      handleGetCity(val);
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="cityName"
                    label="City"
                    control={control}
                    errors={errors}
                    options={CityDrop || []}
                  />
                </Grid>
                {/* <Grid item xs={4}>
                  <CustomSelect
                    name="relationshipManagerId"
                    label="Relationship manager"
                    control={control}
                    errors={errors}
                    options={
                      ReportingManagerListData2.map((user) => ({
                        value: user.userId,
                        label: user.fullName
                      })) || []
                    }
                  />
                </Grid> */}

                <Grid item xs={4}>
                  <CustomSelect
                    name="reportingManagerId"
                    label="Reporting Manager"
                    control={control}
                    errors={errors}
                    options={
                      ReportingManagerListData2.map((user) => ({
                        value: user?.userId,
                        label: user?.userName
                      })) || []
                    }
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomSelect
                    name="typeId"
                    label="User Type"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { id: 304, value: 304, label: 'Employee' },
                      { id: 302, value: 302, label: 'Partner' }
                    ]}
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomSelect
                    name="accessLevelId"
                    label="Access Level"
                    control={control}
                    errors={errors}
                    isRequired
                    options={
                      Array.isArray(AccessLevelList)
                        ? AccessLevelList.map((opt) => ({
                            label:
                              opt?.accessLevelName ??
                              opt?.name ??
                              opt?.label ??
                              opt?.value ??
                              String(opt),
                            value: opt?.accessLevelId ?? opt?.id ?? opt?.value ?? opt
                          }))
                        : []
                    }
                  />
                </Grid>
                {/* <Grid item xs={4}>
                  <CustomSelect
                    name="reportingManagerId"
                    label="Reporting manager"
                    control={control}
                    errors={errors}
                  />
                </Grid> */}
                <Grid item xs={4}>
                  <CustomInput name="userName" label="Username" control={control} errors={errors} />
                </Grid>
              </Grid>
            </form>
          </Box>

          <Box textAlign="right">
            <Button variant="contained" className="mainBtn" type="submit" form="addEditUser">
              {rowId ? 'Update' : 'Save'}
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  );
}

export default AddEditUser;
